import { checkSearchObject } from "app/common/LocalFunction";
import { Organization } from "app/common/Model/Organization";
import { SearchObject } from "app/common/Model/SearchObject";
import { downloadTemplateOrganization, importExcelOrganization } from "app/services/ImportExcelService";
import {
  deleteOrganization,
  getOrganizationById,
  pagingOrganization,
  saveOrUpdateOrganization,
  syncOrganization,
} from "app/services/OrganizationService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class OrganizationStore {
  listAllOrganization = [];
  searchOrganization = new SearchObject();
  pageOrganization = null;
  selectedOrganization = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteOrganization = false;
  recentlyUpdated = false;
  openFormUpLoadFile = false;

  constructor() {
    makeAutoObservable(this);
  }

  importExcelOrganization = (file) => {
    importExcelOrganization(file).then(() => {
      toast.success("Nhập excel thành công")
      this.searchOrganization = {
        ...this.searchOrganization,
        pageIndex: 1
      }
      this.pagingOrgan()

    }).catch(() => {
      toast.error("Nhập excel thất bại")
    }).
      finally(() => {
        this.handleClosePopup()
      })
  }

  handleDownloadTemplateOrganization = async () => {
        try {
          const res = await downloadTemplateOrganization();
          const url = window.URL.createObjectURL(res?.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "MAU_KHU_VUC" + ".xlsx");
          document.body.appendChild(link);
          link.click();
        } catch (error) {
          console.log(error);
        }
    };

  handleUpLoadFile = () => {
    this.openFormUpLoadFile = true
  }

  getAllOrganization = async () => {
    if (!this.listAllOrganization?.length || this.recentlyUpdated) {
      return pagingOrganization({
        pageIndex: 1,
        pageSize: 1000000,
      })
        .then(({ data }) => {
          this.listAllOrganization = data?.content;
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    }
  };

  pagingOrgan = () => {
    pagingOrganization(this.searchOrganization).then(
      ({ data }) => (this.pageOrganization = data)
    );
  };

  handleChangeSearchForm = (searchOrganization) => {
    this.searchOrganization = checkSearchObject(
      this.searchOrganization,
      searchOrganization
    );
    this.pagingOrgan();
  };

  handleOpenFormCreateOrEdit = async (organizationId) => {
    if (Boolean(organizationId)) {
      try {
        const { data } = await getOrganizationById(organizationId);
        if (data) {
          this.selectedOrganization = data;
          this.openFormCreateOrEdit = true;
        }
      } catch {
        toast.error("Lấy dữ liệu có lỗi!");
      }
    } else {
      this.selectedOrganization = new Organization();
      this.openFormCreateOrEdit = true;
    }
  };

  saveOrgan = async (organization, { setSubmitting }) => {
    try {
      const { data } = await saveOrUpdateOrganization(organization);
      if (data) {
        this.selectedOrganization = null;
        this.pagingOrgan();
        this.handleClosePopup();
        this.recentlyUpdated = true;

        toast.success("Lưu cơ sở thành công!");
      }
    } catch {
      toast.error("Lưu cơ sở thất bại!");
    } finally {
      setSubmitting(false);
    }
  };

  handleConfirmDeleteOrgan = async () => {
    try {
      await deleteOrganization(this.selectedOrganization?.id);
      if (
        this.searchOrganization?.pageIndex > 1 &&
        this.pageOrganization?.content?.length === 1
      ) {
        this.searchOrganization.pageIndex -= 1;
      }
      this.pagingOrgan();
      this.recentlyUpdated = true;
      this.handleClosePopup();

      toast.success("Xóa cơ sở thành công!");
    } catch (error) {
      toast.error("Xóa cơ sở thất bại!");
    }
  };

  handleDeleteOrgan = (organizationId) => {
    this.selectedOrganization = { id: organizationId ?? "" };
    this.openConfirmDeleteOrganization = true;
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteOrganization = false;
    this.openFormUpLoadFile = false
  };
  hanleSyncOrganization = () => {
    syncOrganization()
      .then(({ data }) => {
        toast.success("Đồng bộ thành công");
        this.pagingOrgan()
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đồng bộ dữ liệu có lỗi");
      });
  };
  resetStore = () => {
    this.searchOrganization = new SearchObject();
    this.pageOrganization = null;
    this.selectedOrganization = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteOrganization = false;
    this.openFormUpLoadFile = false
  };
}
